import { z } from 'zod';

export const configSchema = z.object({
  url: z.array(z.string()),
  default_map_zoom: z.number(),
});

export const territoryPermissionsSchema = z.object({
  can_create_missions: z.boolean(),
  can_perform_pause_shift: z.boolean(),
  can_perform_roadmap_actions: z.boolean(),
});

export const territorySchema = z.object({
  id: z.number(),
  slug: z.string(),
  config: configSchema,
  integration_state_counts: z.record(z.string(), z.number()),
  metabase_dashboard_url: z.string(),
  backend_version: z.string(),
  permissions: territoryPermissionsSchema,
  providers_health: z.record(z.string(), z.boolean()),
});

export type Config = z.infer<typeof configSchema>;
export type Territory = z.infer<typeof territorySchema>;
